import { Package, PackageStep, PackageStepType } from "../types/api/enrollmentPackages/Package";
import { PlanTypeId } from "../types/api/primaryKeys/PrimaryKey";
import { HarmonyProductGroup } from "../types/thirdParty/harmony/HarmonyProductGroup";

type PackageStepPredicate = (step: PackageStep) => boolean;

const getStep = (currentPackage: Package, predicate: PackageStepPredicate) => {
    
    const { steps } = currentPackage;

    const nextStep = steps?.find(predicate) ?? null;
    return nextStep;
};

const getStepNumber = (currentPackage: Package, predicate: PackageStepPredicate) => {
    const nextStep = getStep(currentPackage, predicate);
    return nextStep === null ? null : nextStep.number;
};

class StepNumberHelper {
    stepNumberForNamedStep = (currentPackage: Package, stepType: PackageStepType) => {
        return getStepNumber(currentPackage, s => s.type.toUpperCase() === stepType.toUpperCase());
    };

    stepNumberForPlanTypeStep = (currentPackage: Package, planTypeId: PlanTypeId) => {
        return getStepNumber(currentPackage, s => s.type.toUpperCase() === PackageStepType.PlanType.toUpperCase() && s.relatedEntityId === planTypeId);
    };

    getNextStep = (currentPackage: Package, currentStepNumber: number) => {
        return getStep(currentPackage, s => s.number === currentStepNumber + 1);
    };

    getPreviousStep = (currentPackage: Package, currentStepNumber: number) => {
        return getStep(currentPackage, s => s.number === currentStepNumber - 1);
    };

    getNumberBasedOnProduct = (currentPackage: Package, productGroup: HarmonyProductGroup) => {
        return getStepNumber(currentPackage, s => s.type.toUpperCase() === PackageStepType.PlanType.toUpperCase() && s.harmonyProductGroup === productGroup);
    };
}


export const stepNumberHelper = new StepNumberHelper();